<!--头部-->
<template>
  <div class="overall-top-wrapper">
    <div class="overall-top-left">
      <div class="overall-top-left-wrapper">
        <a
          v-if="showback"
          class="overall-top-left-back"
          href="javascript:void(0);"
          @click="back"
          ><em></em
        ></a>
        <div class="overall-top-left-box">
          <div class="overall-top-left-local">
            <p class="overall-top-left-name">{{ dealerName }}</p>
            <p
              v-if="showMapIcon && !isSHowSmartGuide"
              class="overall-top-left-icon"
              id="J-Navigation"
              v-stat:click="{ action: 'arhall_map_click' }"
              @click="openMap"
            >
              <em></em>
              <span>地图</span>
            </p>
          </div>
        </div>
        <a
          href="javascript:void(0);"
          class="overall-top-left-smallVideo"
          v-if="showVideoIcon && !isSHowSmartGuide"
          v-stat:show="{ action: 'znzt_shortvideoicon_show' }"
          v-stat:click="{ action: 'znzt_shortvideoicon_click' }"
          @click="openVideo"
        >
          <em></em>
          <span>视频说车</span>
        </a>
      </div>
    </div>
    <RollText v-show="!isSHowSmartGuide"/>
  </div>
</template>
<script>
import RollText from './RollText.vue';
import { mapGetters } from 'vuex';
import * as layerNames from '../services/layerName';
import util from '../utils/util';
import * as queryValue from '../services/query.const';
import { staticIdProxy, actionProxy } from '../services/socketIO/user.action.interceptor';
import layerManager from '../services/layer.manager';
export default {
  components: { RollText },
  props: {
    isSHowSmartGuide: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showback: false
    };
  },
  created: staticIdProxy(function () {
    return;
  }, 'vue_header'),
  mounted () {
    this.$nextTick(() => {
      if (!util.browser.isApp && !util.isICSApp() && !util.browser.isWechat) {
        this.showback = true;
      }
    });
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      hasVideo: 'hasVideo',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
    }),
    dealerName () {
      return this.baseInfo.dealerName;
    },
    dealerId () {
      return this.baseInfo.dealerId;
    },
    showMapIcon () {
      if (this.$queryParams.from === queryValue.QUERY_FROM_GDXIAOCHENGXU) {
        return false;
      }
      return true;
    },
    showVideoIcon () {
      if (this.$queryParams.from === queryValue.QUERY_FROM_GDXIAOCHENGXU) {
        return false;
      }
      return this.hasVideo && !this.phoneCallStatus && this.$queryParams.realtimeanswer !== 1;
    }
  },
  methods: {
    openMap: actionProxy('openMap', function () {
      layerManager.open(layerNames.MAP_LAYER, {}, true);
    }),
    back () {
      var _backurl = this.$queryParams.backUrl;
      if (_backurl) {
        window.location.href = _backurl;
      } else {
        window.history.back();
      }
    },
    openVideo () {
      layerManager.openVideoList();
    },
  }
};
</script>
<style lang="scss">
.overall-top-left {
  position: fixed;
  width: 100%;
  height: ptrd(100px);
  left: 0;
  top: 0;
  z-index: 1;
  &-wrapper {
    display: flex;
    align-items: center;
    height: ptrd(100px);
    padding: 0 ptrd(20px);
    @include gradient-vertical(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
  }
  &-box {
    flex: 1;
    width: 1%;
  }
  &-back {
    display: block;
    width: ptrd(40px);
    height: ptrd(40px);
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAA7ElEQVRYR+3YUQoCMQwE0MxV1YPoPcTLeZBKxYIsqzTpTFrE/S67byf9GAJb/MHiPvsD64RKKTWIq5ndAZw9U5Mn+IY7vGAXD1IK3MFV4w3AsTdFGfATzsxOAMpUIAtXf4KeIBNHB7JxVKACRwOqcBSgEjcMVOOGgBm4MDALFwJm4tzAbJwLOAPXDZyF+x3gphW34vnsdt761Fuz2jlXm5kxahdwRpJuYDYyBMxEhoFZyCFgBnIYqEZSgEokDahCUoEKJB3IRkqATKQM+A25xPKotZGl1287yPUWmN7+tz0vvYOjuO7Kz/hQ9B0Pl/7GKXA/K9cAAAAASUVORK5CYII=)
      no-repeat center center;
    background-size: 100%;
  }
  &-local {
    display: flex;
    align-items: center;
    margin-left: ptrd(10px);
  }
  &-name {
    font-size: ptrd(32px);
    @extend %ellipsis-basic;
    color: #fff;
    font-weight: 600;
  }
  &-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 ptrd(16px);
    height: ptrd(44px);
    border-radius: ptrd(44px);
    margin-left: ptrd(20px);
    background-color: rgba($color: #000000, $alpha: 0.4);
    text-align: center;
    em,
    span {
      display: block;
      font-size: ptrd(24px);
      color: #e6e9f0;
    }
    em {
      width: ptrd(30px);
      height: ptrd(30px);
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADeUlEQVRIS92WzWtjVRjGf2+SJmlTx9A2M7S48ANciLgYgiC4aQd3A5JFKwgKoi4GXLkSRoSRcZGFq1FBcCEu/Af0DxDcjgyIMApj3ImIH9BCqaT3PHLuOefm5qOTmhYGTAj36+T83vc5z/ueazygjz0gLv9P8P6+1g+HRz0nPV1bqnx08eHmvaTwuWecYMjtCtuRVIuwO1ud1uVzBe9L6+5g2Mvk9pzTthM1OZF/FVBm3N3caD11ZrCk9cOjrHfssl1kO86p5jxMwuU/cqi/DmDrb26svLMQ2MOGGb3sONsV7GTO1fy8CVicQw5O9yOsu9VpfXdqsIcBvSzTnmA7ZOYQFjLLU4MsvxeyDEB/DOMQg83OyhPl0p1prgQD9oBt+TWLED+5nzhl5CfzAfjnWQSGsUFm/wzGZc6lT1FMwoDkxnxIymIyswCNkAIcgsmfOajW1O20RzLnYElLwC3g9UlYWZpcunyimG0E5gEZ+3K6EJQIY3JlgsEGl9aWx2RO4KvAV/NaZ5CtvIbyVv3bWeXqco3bB4fH3zjnnhuts4tKWP/iWrNwc2EuSZeA28Aj8+FRQh8B9ieyF+p1u+P/d3A4/NY5PZ/WNZkMq3Y77Xrh5jFXS9oE3gXeAOonBZAMhtkfWcWuNMy+92MPj45vOae3/PonP+SxicF6uzkl85i5/IWkR4H3gFeB6qwAJH4344qZ/SDJ/hm6j7PMXSsvRTrH0V9rN6ZkngKXHP4kcAN4qex84Ddgx8zueuhw6D7NpDcLV6fajS43V+m2Z8h8IrgUwDPA+8CLwK8R+pOkSub4zDn3Wu7qotySAfMSG7QfasyUeS64FMCzwF9mds9Dgc+zTK+kGi6OqaOFLtZvr86W+dTgUgB+3b+Q9HKo61F3KtpkrO8qdFutaTefulePNxFtAL8Aq0WzSI2ltBtl0uDCSv1Emf9zxtH5N4HrqU5DL079O2walYr1V5pLM928UMYR3I5Zt8tbX7mlqqpuq36yzAtlHOHXgZsjU402Cu/m5WbtvjKfBbwKDASd0X4cXnWQ9ZuN6n1lXhgcs34b+LCQOO7XRrVbr9tUb57sggu/ZUpqAj9L2irKyjFo1KtzZT5TxjHra4JPfG/O26ZTf2lpvsznAfYvET9KPO5fuyrGZYs71kk73MLlNDmhpMeAD4CvzezLecD0/F8T7sQ9reo37gAAAABJRU5ErkJggg==)
        no-repeat center center;
      background-size: 100%;
      margin-right: ptrd(4px);
    }
  }
  &-smallVideo {
    font-size: 0;
    flex-shrink: 0;
    padding-left: ptrd(16px);
    em,
    span {
      display: inline-block;
      vertical-align: middle;
    }
    em {
      width: ptrd(44px);
      height: ptrd(44px);
      background: url(data:image/png;base64,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)
        no-repeat center center;
      background-size: 100%;
    }
    span {
      font-size: ptrd(24px);
      color: #fff;
      margin-left: ptrd(10px);
      font-weight: bold;
    }
  }
}
</style>
